import React, {useEffect, useRef} from 'react'
import styled from 'styled-components'

interface Props extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    isFocusOnAppear?: boolean
    height?: number
}

const TextAreaInput: React.FC<Props> = ({isFocusOnAppear, height = 200, ...props}) => {
    const htmlInputRef = useRef<HTMLTextAreaElement>(null)
    useEffect(() => {
        if (htmlInputRef.current && isFocusOnAppear === true) {
            htmlInputRef.current.focus()

            const timeout = setTimeout(() => {
                htmlInputRef.current?.focus()
            }, 0)
            return () => clearTimeout(timeout)
        }
    }, [htmlInputRef]);

    return (
        <StyledTextArea
            ref={htmlInputRef}
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            $height={height}
            {...props}
        />
    )
}

const StyledTextArea = styled.textarea<{ $height: number }>`
    width: 100%;
    height: ${({ $height }) => $height}px;
    padding: 16px;
    border: none;
    border-radius: 16px;
    background-color: var(--search-field-bg-color);
    color: var(--text-color);
    font-size: 16px;
    line-height: 1.5;
    resize: none;
    outline: none;
    transition: background-color 0.2s ease, border-color 0.2s ease;

    &:focus {
        background-color: var(--input-focus-bg-color);
    }

    &::placeholder {
        color: var(--sub-text-color);
    }

    &:disabled {
        opacity: 0.4;
        cursor: default;
    }
`

export default TextAreaInput
